import { useInternalAdmin } from 'hooks'
import { getMainCampaignNameFromCategory } from 'main/campaignNamesAndDesc'
import moment from 'moment'
import { useSelector } from 'react-redux'

import styles from './ConversationBubble.module.scss'
import { ReactComponent as InfoIcon } from './info.svg'

const DeliveryStatus = ({
  hovering,
  deliveryStatus,
  isSenderClient,
  deliveryError,
  category,
  sentOn,
  shouldApplyOffset
}) => {
  const isInternalAdmin = useInternalAdmin()

  const { currentUtcOffset } = useSelector(s => s.login)

  const campaignName = category ? getMainCampaignNameFromCategory(category) : ''

  if (isSenderClient) {
    return null
  }

  if (!isInternalAdmin && hovering) {
    return (
      <div className={styles.deliveryStatusHover}>
        {shouldApplyOffset ? (
          <>
            {campaignName && <>{campaignName} - </>}
            Sent on {moment(sentOn).utcOffset(currentUtcOffset).format('MMM D, h:mm A')}
          </>
        ) : (
          <>
            {campaignName && <>{campaignName} - </>}
            Sent on {moment(sentOn).format('MMM D, h:mm A')}
          </>
        )}
      </div>
    )
  }

  if (!isInternalAdmin && !hovering) {
    return null
  }

  if (hovering && deliveryStatus.match(/delivered/i)) {
    return (
      <div className={styles.deliveryStatusHover}>
        {isInternalAdmin && category && <>{campaignName} - </>}
        {deliveryStatus}
      </div>
    )
  }

  if (deliveryStatus.match(/delivered/i)) {
    return null
  }

  if (deliveryStatus.match(/deliveryFailed/i)) {
    return (
      <div className={styles.deliveryStatusFailed} data-tip={deliveryError}>
        <InfoIcon />
        Delivery failed: {deliveryError || 'Unknown error'}
      </div>
    )
  }

  return <div className={styles.deliveryStatus}>{deliveryStatus}</div>
}

export default DeliveryStatus
